import {
  QuantaForm,
  Modal,
  Button,
  InputGridGroup,
  DataGridGroup,
  useResponsiveParams,
  useQuantaFormikContext,
  Text,
} from 'quanta-ui';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faSave,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

export default function ModalMedicalQuestionaire({
  medicalQuestionaireData,
  medicalQuestionaireDisplay,
  setMedicalQuestionaireDisplay,
  readOnlyMode,
  insuredDetails,
  valuesBeforeEdit,
  masterQuestion,
  questions,
  productCode,
}) {
  const [brandName] = useState('Kotak');
  const [address] = useState('Random Address');

  const { errors, setFieldValue } = useQuantaFormikContext();

  let repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 1,
  });

  let questionData =
    Object.keys(medicalQuestionaireData)?.length > 0
      ? Object.keys(medicalQuestionaireData)?.map((m) => {
          return {
            title: (
              <Text
                type="large"
                className={`${
                  insuredDetails[m]?.isMemberDeleted ||
                  insuredDetails[m]?.memberID
                    ? 'text-neutral-darker'
                    : ''
                }`}
              >
                {m}
              </Text>
            ),
            size: 'medium',
            grid_data: !medicalQuestionaireData[`${m}`]
              ? []
              : medicalQuestionaireData[`${m}`]['MASTER'] &&
                (medicalQuestionaireData[`${m}`]['MASTER']
                  ?.checkboxAnswer === '' ||
                  medicalQuestionaireData[`${m}`]['MASTER']
                    ?.checkboxAnswer ===
                    (!masterQuestion?.condToChild ? '' : 'No'))
              ? [
                  {
                    type: 'radiogroup',
                    label: (
                      <Text className={'break-all'}>
                        {masterQuestion?.label}
                      </Text>
                    ),
                    name: `medicalUnderwriting.${m}.${
                      questions.find(
                        (q) => q?.srNo?.toLowerCase() === 'master',
                      )?.srNo
                    }.checkboxAnswer`,
                    disabledGlobal:
                      readOnlyMode ||
                      insuredDetails[m]?.isMemberDeleted ,
                      // ||
                      // (insuredDetails[m]?.memberID !== '' &&
                      //     insuredDetails[m]?.memberID !== null &&
                      //     insuredDetails[m]?.memberID !== undefined),
                    flow: 'row',
                    className:
                      'items-baseline justify-between space-x-4',
                    data: [
                      {
                        label: 'Yes',
                        value: 'Yes',
                      },
                      {
                        label: 'No',
                        value: 'No',
                      },
                    ],
                  },
                ]
              : [
                  {
                    type: 'radiogroup',
                    label: (
                      <Text className={'break-all'}>
                        {masterQuestion?.label}
                      </Text>
                    ),
                    name: `medicalUnderwriting.${m}.${masterQuestion?.srNo}.checkboxAnswer`,
                    disabledGlobal:
                      readOnlyMode ||
                      insuredDetails[m]?.isMemberDeleted ,
                      // ||
                      // (insuredDetails[m]?.memberID !== '' &&
                      //     insuredDetails[m]?.memberID !== null &&
                      //     insuredDetails[m]?.memberID !== undefined),
                    flow: 'row',
                    className:
                      'items-baseline justify-between space-x-4',
                    data: [
                      {
                        label: 'Yes',
                        value: 'Yes',
                      },
                      {
                        label: 'No',
                        value: 'No',
                      },
                    ],
                  },
                  ...questions
                    ?.filter(
                      (q) => q?.srNo?.toLowerCase() !== 'master',
                    )
                    ?.flatMap((q) => {
                      if (!q.isParent) {
                        const parentQuestion = questions?.find(
                          (question) =>
                            question?.childQuesNo?.find(
                              (c) =>
                                c.toLowerCase() ===
                                q.srNo.toLowerCase(),
                            ),
                        );
                        if (
                          parentQuestion &&
                          ((medicalQuestionaireData[`${m}`][
                            `${parentQuestion.srNo}`
                          ]?.checkboxAnswer === 'Yes' &&
                            !parentQuestion.condToChild) ||
                            (medicalQuestionaireData[`${m}`][
                              `${parentQuestion.srNo}`
                            ]?.checkboxAnswer === 'No' &&
                              parentQuestion?.condToChild))
                        ) {
                          return null;
                        }
                      }
                      if (
                        q?.isChkTxtReq &&
                        medicalQuestionaireData[`${m}`][q.srNo]
                          ?.checkboxAnswer === 'Yes'
                      ) {
                        return [
                          {
                            type: 'radiogroup',
                            label: (
                              <Text className={'break-all'}>
                                {q?.label}
                              </Text>
                            ),
                            name: `medicalUnderwriting.${m}.${q?.srNo}.checkboxAnswer`,
                            disabledGlobal:
                              readOnlyMode ||
                              insuredDetails[m]?.isMemberDeleted ,
                              // ||
                              // (insuredDetails[m]?.memberID !== '' &&
                              // insuredDetails[m]?.memberID !==
                              //   null &&
                              // insuredDetails[m]?.memberID !==
                              //     undefined),
                            flow: 'row',
                            className:
                              'items-baseline justify-between space-x-4',
                            data: [
                              {
                                label: 'Yes',
                                value: 'Yes',
                              },
                              {
                                label: 'No',
                                value: 'No',
                              },
                            ],
                          },
                          {
                            type: 'textarea',
                            name: `medicalUnderwriting.${m}.${q?.srNo}.textareaAnswer`,
                            disabled:
                              readOnlyMode ||
                              insuredDetails[m]?.isMemberDeleted,
                              //  ||
                              // (insuredDetails[m]?.memberID !== '' &&
                              //     insuredDetails[m]?.memberID !==
                              //       null &&
                              //     insuredDetails[m]?.memberID !==
                              //     undefined),
                            flow: 'col',
                            rows: 1,
                            maxLength: 500,
                          },
                        ];
                      }
                      if (!q.isChkReq) {
                        return {
                          type: 'textarea',
                          label: (
                            <Text className={'break-all'}>
                              {q?.label} (max 500 characters)
                            </Text>
                          ),
                          name: `medicalUnderwriting.${m}.${q?.srNo}.textareaAnswer`,
                          disabled:
                            readOnlyMode ||
                            insuredDetails[m]?.isMemberDeleted,
                            //  ||
                            // (insuredDetails[m]?.memberID !== ''&&
                            // insuredDetails[m]?.memberID !== null &&
                            // insuredDetails[m]?.memberID !==
                            //     undefined),
                          flow: 'col',
                          rows: 1,
                          maxLength: 500,
                        };
                      }
                      return {
                        type: 'radiogroup',
                        label: (
                          <Text className={'break-all'}>
                            {q?.label}
                          </Text>
                        ),
                        name: `medicalUnderwriting.${m}.${q?.srNo}.checkboxAnswer`,
                        disabledGlobal:
                          readOnlyMode ||
                          insuredDetails[m]?.isMemberDeleted,
                          //  ||
                          // (insuredDetails[m]?.memberID !== '' &&
                          // insuredDetails[m]?.memberID !== null &&
                          // insuredDetails[m]?.memberID !==
                            // undefined),
                        flow: 'row',
                        className:
                          'items-baseline justify-between space-x-4',
                        data: [
                          {
                            label: 'Yes',
                            value: 'Yes',
                          },
                          {
                            label: 'No',
                            value: 'No',
                          },
                        ],
                      };
                    })
                    .filter((q) => q),
                ],
          };
        })
      : [];

  const disclaimerInformation = [
    {
      title: (
        <span className="text-black font-bold">
          Disclaimer/ Privacy Policy
        </span>
      ),
      grid_data: [
        {
          colSpan: 1,
          text: (
            <Text type="label" className="text-base text-black">
              Insurance is the subject matter of solicitation. The
              advertisement contains only an indication of cover
              offered . For more details on risk factors, terms,
              conditions and exclusions , please read the sales
              brochures carefully before concluding a sale. Trade logo displayed above belongs to Kotak Mahindra Bank Ltd. and Zurich Insurance Company Ltd, Switzerland and is used by Zurich Kotak General Insurance Company (India) Limited under license.  CIN: U66000MH2014PLC260291. IRDAI Reg. No.152.
              Registered & Corporate Office: 401, 4th Floor, Silver Metropolis, Jai Coach Compound, Off Western Express Highway, Goregaon (East), Mumbai- 400063. Maharashtra, India.
            </Text>
          ),
        },
      ],
    },
  ];

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 3,
    gap: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    useExpandablePaper: true,
  };
  if (productCode ==='2885' || productCode=== '2877'){
    questionData=questionData.map((q)=>{
     return{
       title:q.title,
       size:q.size,
       grid_data:q.grid_data.filter((g,idx)=>idx !==0)
     }
    })}
  return (
    <Modal
      display={medicalQuestionaireDisplay}
      size="full"
      title={'Medical Questionaire'}
      className="h-screen flex flex-col justify-start"
      direction="down"
      onClose={(_) => {
        setFieldValue(`medicalUnderwriting`, valuesBeforeEdit);
        setMedicalQuestionaireDisplay(false);
      }}
    >
      <QuantaForm className="space-y-4">
        {/* {Object.keys(insuredDetails)?.find(
          (insured) =>
          !insuredDetails[insured]?.memberID &&
            !insuredDetails[insured]?.isSoftAdded,
        ) == undefined && (
          <Text
            severity="warning"
            type="normal"
            className="my-2 flex space-x-2 justify-start"
          >
            <Text>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </Text>
            <Text>
              Member information can only be filled for newly added
              members
            </Text>
          </Text>
        )} */}
        <InputGridGroup {...{ data: questionData, ...other_props }} />
        <DataGridGroup
          data={disclaimerInformation}
          repeat={1}
          textType="label"
          titleType="title"
          titleSeverity="info"
          nullData={() => (
            <Text severity="neutral">Not Captured</Text>
          )}
        />
        {errors?.medicalUnderwritingMasterQuestion && (
          <Text className="flex space-y-2" severity={'error'}>
            {errors?.medicalUnderwritingMasterQuestion}
          </Text>
        )}
        <div className="flex justify-end space-x-4">
          <span>
            <Button
              type={'button'}
              flat={false}
              size="small"
              className="h-10 w-28"
              onClick={(_) => {
                setMedicalQuestionaireDisplay(false);
                document.body.classList.remove('overflow-y-hidden');
              }}
              iconPre={
                <FontAwesomeIcon
                  icon={faSave}
                  className="mx-2 w-32"
                />
              }
              disabled={
                (errors?.medicalUnderwriting &&
                  Object?.keys(errors?.medicalUnderwriting)?.length >
                    0) ||
                (errors?.medicalUnderwritingMasterQuestion !== null &&
                  errors?.medicalUnderwritingMasterQuestion !==
                    undefined &&
                  errors?.medicalUnderwritingMasterQuestion !== '') ||
                readOnlyMode
                //  ||
                // Object.keys(insuredDetails)?.find(
                //   (insured) =>
                //   !insuredDetails[insured]?.memberID &&
                //     !insuredDetails[insured]?.isSoftAdded,
                // ) === undefined
              }
            >
              Save
            </Button>
          </span>
          <span>
            <Button
              type={'button'}
              flat
              className="h-10 w-28"
              size="small"
              onClick={(_) => {
                setFieldValue(
                  `medicalUnderwriting`,
                  valuesBeforeEdit,
                );
                setMedicalQuestionaireDisplay(false);
                document.body.classList.remove('overflow-y-hidden');
              }}
              iconPre={
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className="mx-2 w-32"
                />
              }
            >
              Cancel
            </Button>
          </span>
        </div>
      </QuantaForm>
    </Modal>
  );
}
